import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";
const getComments = credentials => {
    let url = apiUrlWithLang('/dashboard/api/comments')
    return axios.get(url, { params:credentials })
}

export default {
    getComments,
}